module.exports = "<p>\n  contributors works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contributors/contributors.component.html
// module id = 206
// module chunks = 1